export enum DataHooks {
  ROOT = 'header-root',
}
